import Lib from '../../commons/lib';

export default class Service {
  static szamlazasUrl = window.location.origin + '/api/szamlazas/';

  // NYUGTA START

  static initNyugtaFilter(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.szamlazasUrl + 'nyugta/list/init',
      args: { requestType: 'nyugta-list-init' },
    }], fnDone);
  }

  static serachBizonylat(bizonylatSzam, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.szamlazasUrl + 'nyugta/list/searchbizonylat',
      args: { requestType: 'nyugta-list-searchbizonylat' },
      params: { szam: bizonylatSzam },
    }], fnDone);
  }

  static listNyugta(nyugtaSzuro, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.szamlazasUrl + 'nyugta/list',
      args: { requestType: 'nyugta-list' },
      data: nyugtaSzuro
    }], fnDone);
  }

  static sztornoNyugta(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.szamlazasUrl + 'nyugta/sztorno/id',
      args: { requestType: 'nyugta-sztorno' },
      data: {
        id: id,
        kezi: true
      }
    }], fnDone);
  }

  static getNyugta(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.szamlazasUrl + 'nyugta',
      args: { requestType: 'nyugta-get' },
      params: { id: id }
    }], fnDone);
  }

  static listXlsx(partnerIds, kvb, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.szamlazasUrl + 'nyugta/xlsx',
      acceptType: 'application/json, application/octet-stream',
      args: { requestType: 'nyugta-xlsx' },
      data: {
        ids: partnerIds,
        kvb: kvb
      }
    }], fnDone);
  }

  static pdfNyugta(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.szamlazasUrl + 'nyugta/pdf',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      withFileName: true,
      params: { id: id }
    }], fnDone);
  }

  // NYUGTA END
}